var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 70 70",
    style: {
      width: "1em"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 68.614L68.612 70 34.999 36.387 1.384 70 0 68.614l33.613-33.613L0 1.388 1.384 0l33.615 33.615L68.612 0 70 1.388 36.385 35.001 70 68.614z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgdmlld0JveD0iMCAwIDcwIDcwIiBzdHlsZT0id2lkdGg6IDFlbTsiPgogIDxwYXRoCiAgICBkPSJNNzAgNjguNjE0TDY4LjYxMiA3MEwzNC45OTkgMzYuMzg3TDEuMzg0MDQgNzBMMCA2OC42MTRMMzMuNjEzIDM1LjAwMUwwIDEuMzg3OTZMMS4zODQwNCAwTDM0Ljk5OSAzMy42MTVMNjguNjEyIDBMNzAgMS4zODc5NkwzNi4zODUgMzUuMDAxTDcwIDY4LjYxNFoiCiAgPjwvcGF0aD4KPC9zdmc+";
export { SvgClose as ReactComponent };